/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does the gap-to-leader column matter for fantasy?`)
};

const es_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué importa la columna de diferencia con el líder para el fantasy?`)
};

const de_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ist die Spalte „Rückstand auf den Führenden“ für Fantasy wichtig?`)
};

const nl_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is de kolom achterstand-op-koploper belangrijk voor fantasy?`)
};

const fr_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi la colonne d'écart avec le leader compte-t-elle pour le fantasy ?`)
};

const it_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché la colonna del distacco dal leader è importante per il fantasy?`)
};

const pt_br2_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que a coluna de diferença para o líder importa para o fantasy?`)
};

const pt_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que a coluna de diferença para o líder importa para o fantasy?`)
};

const ja_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜリーダーとの差の列がファンタジーにとって重要なのですか？`)
};

const zh_f1_st_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么与领跑者的差距一栏对梦幻游戏很重要？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_st_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_st_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_st_faq4_q", locale)
	if (locale === "en") return en_f1_st_faq4_q(inputs)
	if (locale === "es") return es_f1_st_faq4_q(inputs)
	if (locale === "de") return de_f1_st_faq4_q(inputs)
	if (locale === "nl") return nl_f1_st_faq4_q(inputs)
	if (locale === "fr") return fr_f1_st_faq4_q(inputs)
	if (locale === "it") return it_f1_st_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_st_faq4_q(inputs)
	if (locale === "pt") return pt_f1_st_faq4_q(inputs)
	if (locale === "ja") return ja_f1_st_faq4_q(inputs)
	return zh_f1_st_faq4_q(inputs)
};